export interface Citation {
  fileId?: string;
  filename?: string;
  quote?: string;
  url?: string;
  title?: string;
  startIndex?: number;
  endIndex?: number;
}

export function safeCitationUrl(value: string | undefined): string | undefined {
  if (!value || value.length > 2048) return undefined;
  try {
    const url = new URL(value);
    if (url.protocol !== 'https:' || url.username || url.password || url.port) return undefined;
    return url.href;
  } catch {
    return undefined;
  }
}

export function citationSegments(
  text: string,
  citations: Citation[] | null = [],
): Array<{ text: string; url?: string }> {
  const parts: Array<{ text: string; url?: string }> = [];
  let cursor = 0;
  for (const citation of [...(citations ?? [])].sort(
    (a, b) => (a.startIndex ?? 0) - (b.startIndex ?? 0),
  )) {
    const { startIndex: start, endIndex: end } = citation;
    const url = safeCitationUrl(citation.url);
    if (
      !url ||
      start === undefined ||
      end === undefined ||
      !Number.isInteger(start) ||
      !Number.isInteger(end) ||
      start < cursor ||
      end <= start ||
      end > text.length
    )
      continue;
    if (start > cursor) parts.push({ text: text.slice(cursor, start) });
    parts.push({ text: text.slice(start, end), url });
    cursor = end;
  }
  parts.push({ text: text.slice(cursor) });
  return parts;
}
